/* Waïloa – menu mobile : panneau fixe et page verrouillée pendant l'ouverture (iOS Safari compris).
   Le thème ouvre le panneau en lui ajoutant .menu-sidebar-visible : on observe ce changement.
   Styles associés : assets/wl-nav-lock.css. */
(function () {
  var root = document.documentElement, body = document.body;
  var locked = false, y = 0, kept = [], sec = null;
  function panel() { return document.querySelector('.menu-sidebar.wl-mm-host[data-menu-items]'); }
  function isOpen() { var m = panel(); return !!(m && m.classList.contains('menu-sidebar-visible')); }
  function setTop() {
    var h = document.querySelector('header[data-header-section]');
    if (!h) return;
    root.style.setProperty('--wl-mm-top', Math.max(0, Math.round(h.getBoundingClientRect().bottom)) + 'px');
  }
  function keep() { kept.forEach(function (c) { body.classList.add(c); }); }
  function lock() {
    if (locked) return;
    locked = true; window.wlMmLocked = true;
    y = window.scrollY || window.pageYOffset || 0;
    kept = ['sticky-header', 'wl-scrolled'].filter(function (c) { return body.classList.contains(c); });
    var h = document.querySelector('header[data-header-section]');
    sec = h ? (h.closest('.shopify-section') || h.parentElement) : null;
    if (sec) {
      root.style.setProperty('--wl-hdr-top', Math.max(0, Math.round(sec.getBoundingClientRect().top)) + 'px');
      sec.classList.add('wl-mm-pinned');
    }
    setTop();
    root.style.setProperty('--wl-lock-y', (-y) + 'px');
    root.classList.add('wl-mm-lock');
    requestAnimationFrame(function () { keep(); setTop(); });
    setTimeout(function () { keep(); setTop(); }, 80);
    setTimeout(keep, 250);
  }
  function unlock() {
    if (!locked) return;
    locked = false;
    root.classList.remove('wl-mm-lock');
    root.style.removeProperty('--wl-lock-y');
    if (sec) { sec.classList.remove('wl-mm-pinned'); sec = null; }
    var sb = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';
    window.scrollTo(0, y);
    root.style.scrollBehavior = sb;
    setTimeout(function () { window.wlMmLocked = false; }, 50);
  }
  function sync() { if (isOpen() && window.innerWidth < 992) lock(); else unlock(); }
  function watch() {
    var m = panel();
    if (!m || m._wlLock) return;
    m._wlLock = true;
    if ('MutationObserver' in window) new MutationObserver(sync).observe(m, { attributes: true, attributeFilter: ['class'] });
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
  document.addEventListener('shopify:section:load', function () { unlock(); watch(); });
  window.addEventListener('resize', function () { if (locked) { if (window.innerWidth >= 992) unlock(); else setTop(); } });
  window.addEventListener('orientationchange', function () { setTimeout(sync, 300); });
  window.addEventListener('pagehide', unlock);
})();
